import { useOrganization } from "../App";

export type CallBackendName = "v1" | "v2";

/**
 * Which call backends the current organization may use (organizations.feature_flags, set by
 * platform admins on the organization's features page): voice_v2, voice_v1, video_v1.
 *
 * A missing flag counts as on, so organizations created before the flags existed keep
 * everything; new organizations are created with only voice_v2 on. The API server enforces the
 * same rule; this only hides what would be refused.
 */
export function useBackendFlags() {
  const { currentOrganization } = useOrganization();
  const flags = currentOrganization?.feature_flags || {};
  const on = (flag: string) => flags[flag] !== false;

  const voiceV1 = on("voice_v1");
  const voiceV2 = on("voice_v2");
  const videoV1 = on("video_v1");
  const voiceBackends: CallBackendName[] = [
    ...(voiceV1 ? (["v1"] as const) : []),
    ...(voiceV2 ? (["v2"] as const) : []),
  ];
  // Same default as the API server: v1 as before, v2 once V1 voice is turned off
  const defaultBackend: CallBackendName = voiceV1 ? "v1" : "v2";

  return { voiceV1, voiceV2, videoV1, voiceBackends, defaultBackend };
}
